/**
 *
 * Details Service Constants
 *
 */

import { SERVICE_NAMESPACE, TRANSFER_TYPES } from 'common';
import { TRANSFER_DIRECTIONS } from '../search';

export const URL = (apiUrl, transferId) => `${apiUrl}/evaluated_transfers/${transferId}`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/details`;

// Trigger a fetch request in sagas
export const DETAILS_REQUEST = `${NAMESPACE}/DETAILS_REQUEST`;

// Current status of the service
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const FAILURE = `${NAMESPACE}/FAILURE`;
export const UPDATE_CURRENT_TRANSFER = `${NAMESPACE}/UPDATE_CURRENT_TRANSFER`;

export const IS_INCOMING_WIRE = (method, direction) => (
  method === TRANSFER_TYPES.wire &&
  direction === TRANSFER_DIRECTIONS.transferDirectionDeposit
);



// WEBPACK FOOTER //
// ./src/services/details/constants.js